<template>
   <v-dialog v-model="isUserSettingsDialogVisible" fullscreen hide-overlay transition="dialog-bottom-transition">
         <v-card>
         <v-toolbar dark color="primary">
            <v-btn icon dark @click="$store.dispatch('togggleUserSettingsDialogVisible')">
               <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>{{$t('message.userSettings')}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <!-- <v-toolbar-items>
               <v-btn dark flat @click="dialog = false">Save</v-btn>
            </v-toolbar-items> -->
         </v-toolbar>
         <v-list three-line subheader>
            <v-subheader>User Controls</v-subheader>
            <!-- <v-list-tile avatar>
               <v-list-tile-content>
               <v-list-tile-title>Content filtering</v-list-tile-title>
               <v-list-tile-sub-title>Set the content filtering level to restrict apps that can be downloaded</v-list-tile-sub-title>
               </v-list-tile-content>
            </v-list-tile>
            <v-list-tile avatar>
               <v-list-tile-content>
               <v-list-tile-title>Password</v-list-tile-title>
               <v-list-tile-sub-title>Require password for purchase or use password to restrict purchase</v-list-tile-sub-title>
               </v-list-tile-content>
            </v-list-tile> -->
         </v-list>
         <v-divider></v-divider>
         <v-list three-line subheader>
            <v-subheader>{{$t('message.languages')}}</v-subheader>
            <v-list-tile v-for="language in languages" :key="language.name" @click="changeLanguage(language)">
					<img class="img-responsive mr-3" :src="`/static/flag-icons/${language.icon}.png`">
					<span>{{ language.name }}</span>
				</v-list-tile>
             <v-subheader>{{$t('message.general')}}</v-subheader>
            <!-- <v-list-tile avatar>
               <v-list-tile-action>
                  <v-checkbox @change="changeDarkMode" :input-value="darkMode"></v-checkbox>
               </v-list-tile-action>
               <v-list-tile-content>
                  <v-list-tile-title>{{$t('message.darkMode')}}</v-list-tile-title>
                  <v-list-tile-sub-title>{{$t('message.darkModeDescription')}}</v-list-tile-sub-title>
               </v-list-tile-content>
            </v-list-tile>
             <v-subheader>Notifications (debug)</v-subheader>
            <v-list-tile avatar>
               <v-list-tile-action>
                  <v-slider @change="changeOrders" thumb-label="always"></v-slider>
               </v-list-tile-action>
            
            </v-list-tile> -->
            <!-- <v-list-tile avatar>
               <v-list-tile-action>
               <v-checkbox v-model="sound"></v-checkbox>
               </v-list-tile-action>
               <v-list-tile-content>
               <v-list-tile-title>Sound</v-list-tile-title>
               <v-list-tile-sub-title>Auto-update apps at any time. Data charges may apply</v-list-tile-sub-title>
               </v-list-tile-content>
            </v-list-tile>
            <v-list-tile avatar>
               <v-list-tile-action>
               <v-checkbox v-model="widgets"></v-checkbox>
               </v-list-tile-action>
               <v-list-tile-content>
               <v-list-tile-title>Auto-add widgets</v-list-tile-title>
               <v-list-tile-sub-title>Automatically add home screen widgets</v-list-tile-sub-title>
               </v-list-tile-content>
            </v-list-tile> -->
         </v-list>
      </v-card>
    </v-dialog>
</template>
<script>
   import { getCurrentAppLayout } from "Helpers/helpers"
   import { mapGetters } from 'vuex'

   export default{
      data() {
         return {

         }
      },
      computed: {
         ...mapGetters([
            'darkMode',
            'user',
            'isUserSettingsDialogVisible',
            'languages'
         ])
      },
      methods: {
         changeDarkMode () {
            this.$store.dispatch('toggleDarkMode')
         },
         changeOrders (v) {
            this.$store.dispatch('setNewOrderCount', v)
         },
         changeLanguage(language) {
				this.$i18n.locale = language.locale;
				this.$store.dispatch("changeLanguage", language);
			}
      }
   }
</script>
